import { AxiosResponse } from 'axios';
import FormattedVehicle from '../models/FormattedVehicle';
import AppConstants from '../constants/AppConstants';
import EnumService from './EnumService';
import { FileParameter, FormAnswerBaseReq, FormQuestionTextualReq, FormReq, FormSubmissionDeleteMediaFileReq, GetFormSubmissionsReq, VehicleReq, VehicleRes, VehicleResPage } from '../proxy/proxy';
import { AxiosFormsClient, AxiosFormSubmissionsClient, AxiosRegularExpressionsClient } from '../proxy/ProxyClients';

// const api = new Client(AppConstants.BASE_API_URL, AxiosFormsClient);

const FormsService = {
  createForm: (data: FormReq) => AxiosFormsClient.create(data),
  updateForm: (formId: number, data: FormReq) => AxiosFormsClient.update(formId, data),
  addQuestion: (id: number, data: FormQuestionTextualReq) =>
    AxiosFormsClient.addQuestion(id, data),
  deleteQuestion: (formId: number, questionId: string) =>
    AxiosFormsClient.deleteQuestion(formId, questionId),
  replaceQuestion: (formId: number, questionId: string, data: FormQuestionTextualReq) =>
    AxiosFormsClient.replaceQuestion(formId, questionId, data),
  getFormById: (id: number) =>
    AxiosFormsClient
      .get(id)
      .then((resp) => resp),
  getFormByRole: (id: number) =>
    AxiosFormsClient
      .getByRole(id)
      .then((resp) => resp),
  getAllForms: () =>
    AxiosFormsClient
      .all()
      .then((resp) => resp),
  allFormsByRole: () =>
    AxiosFormsClient
      .allByRole()
      .then((resp) => resp),
  getAllRegularExpressions: () =>
    AxiosRegularExpressionsClient
      .all()
      .then((resp) => resp),
  deleteForm: (id: number = 0) => AxiosFormsClient.softDelete(id),
  setIsActive: (id: number = 0, isActive: boolean) =>
    AxiosFormsClient.setIsActive(id, isActive),

  // SUBMISSION
  answer: (data: FormAnswerBaseReq) => AxiosFormSubmissionsClient.answer(data),
  uploadPhoto: (
    formId: number | undefined,
    formQuestionId: string | undefined,
    mediaFileDescription: string | undefined,
    mediaFileFile: FileParameter | undefined
  ) =>
    AxiosFormSubmissionsClient.uploadPhoto(
      formId,
      formQuestionId,
      mediaFileDescription,
      mediaFileFile
    ),
  deletePhoto: (media: FormSubmissionDeleteMediaFileReq) => AxiosFormSubmissionsClient.deletePhoto(media),
  getLatestByUser: (formId: number) => AxiosFormSubmissionsClient.getLatestByUser(formId),
  getSubmission: (submissionId: number) => AxiosFormSubmissionsClient.get(submissionId),
  getSubmissionByUser: (submissionId: number) => AxiosFormSubmissionsClient.getByUser(submissionId),
  submit: (formSubmissionId: number) => AxiosFormSubmissionsClient.submit(formSubmissionId),
  between: (data: GetFormSubmissionsReq) => AxiosFormSubmissionsClient.between(data),
  betweenByUser: (data: GetFormSubmissionsReq) => AxiosFormSubmissionsClient.betweenByUser(data),
};

export default FormsService;
